import {
  Box,
  Flex,
  Text,
  useColorMode,
  CheckSvg,
  spacing,
  color,
} from 'deepstash-ui';
import React from 'react';

interface OwnProps {}

export const ReportModalConfirmation: React.FC<OwnProps> = () => {
  const { colorMode } = useColorMode();

  return (
    <>
      <Flex
        fontSize="1.75rem"
        lineHeight="2.375rem"
        fontWeight="bold"
        color={color[colorMode].text}
        align="center"
        pt={spacing.L.rem}
      >
        <CheckSvg color={color.success} boxSize="1.5rem" />
        <Text>Report sent.</Text>
      </Flex>
      <Box px="0px" pb={spacing.XXL.rem}>
        <Text color={color[colorMode].textSecondary} align="center">
          Thank you for reporting! Our team will look into it as quickly as
          possible and take all the necessary actions.
        </Text>
      </Box>
    </>
  );
};
